import React from 'react';
import { Text, RichText, withPlaceholder } from '@sitecore-jss/sitecore-jss-react';
import Card from '@component/Card';
import i18n from 'i18next';

const CardComponent = (props) => {
  const themeObject = props.params.Theme === undefined ? '' : JSON.parse(props.params?.Theme);
  const themeColor = themeObject?.Color === undefined ? '' : themeObject?.Color.value;
  const target = props.fields?.link?.value?.target === '' ? '_self' : props.fields?.link?.value?.target;
  return (
    <>
      <Card
        title={<Text field={props.fields?.title} />}
        subtitle={<Text field={props.fields?.subtitle} />}
        body={<RichText field={props.fields?.copy} />}
        cta={i18n.t('button/view') || 'View'}
        variant={themeColor}
        handleClick={() => {
          {
            props.fields?.link?.value?.href && window.open(props.fields?.link?.value?.href, target);
          }
        }}
      />
    </>
  );
};
export default withPlaceholder('Card-Grid-Card')(CardComponent);
